<template>
  <el-dialog :title="title" @close="handleClose" :visible.sync="dialogStatus" :width="width + 'px'" :close-on-click-modal="false" :showClose="showClose">
    <component ref='children' :is="dialogComponent" @handleCancle='handleCancle' @handleSubmit='handleSubmit' :payload='payload'></component >
  </el-dialog>
</template>
<script>

export default {
  data() {
    return {
      title: '提示',
      dialogType: '', //  加载的动态组件类型
      width: 430,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      dialogStatus: false,
      submitAction: null,
      cancleAction: null,
      showClose: true,
      payload: {}
    }
  },
  computed: {
    dialogComponent() {
      if (!this.dialogType) return ''
      return () => import(`@/components/Model/${this.dialogType}.vue`)
    }
  },
  watch: {
    dialogStatus(val) {
      if (!val) {
        Object.assign(this.$data, this.$options.data())
      }
    },
    dialogComponent(val) {
    }
  },
  methods: {
    setDialogType(dialogType) {
      this.dialogStatus = true
      this.dialogType = dialogType
    },
    handleClose() {},
    handleCancle(type = 'cancle') {
      this.dialogStatus = false
      this.cancleAction && this.cancleAction({ type })
    },
    handleSubmit(payload) {
      this.submitAction && this.submitAction(payload)
      this.dialogStatus = false
    }
  }
}
</script>
<style lang="scss">
.v-model {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .5;
  background: #000;
  z-index: 1000;
}
.ai-message-box__wrapper{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 2001;
  .ai-message-box__close{
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    &:hover{
      color: #ff8533;
    }
  }
  &:after{
    content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }
  .ai-message-box {
    display: inline-block;
    width: 437px;
    padding: 32px 32px 24px;
    vertical-align: middle;
    background-color: #FFF;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    font-size: 18px;
    box-shadow:0px 4px 12px 0px rgba(0,0,0,0.2);
    text-align: left;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    position: relative;
    .ai-message-box__header {
      font-size:16px;
      font-weight:500;
      color:rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      div{
        color: #FFD000;
        font-size: 22px;
        width: 38px;
      }
      span{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,0.85);
      }
    }
    .ai-message-box__content{
      font-size:14px;
      font-weight:400;
      color:rgba(0,0,0,0.65);
      line-height:22px;
      margin-left: 38px;
      margin-top: 12px;
      min-height: 54px;
    }
    .ai-message-box__btns{
      margin-left: 38px;
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;

    }
  }
}

</style>
